import { Colors } from '../consts/Colors.js';

export default class AnimatedMenu extends Phaser.GameObjects.Container {
    constructor(scene, level) {
        super(scene, 0, 0, []);
        scene.add.existing(this);
        this.scene = scene;

        this.groupIndex = level < 4 ? 0 : 1;
        this.level = level;

        this.isActive = undefined
        this.cartoucheWidthA = undefined
        this.title = undefined

        if (this.groupIndex === 0) {
            this.isActive = 'partieA'
            this.cartoucheWidthA = 1575
            this.title = "Qu'est-ce qu'un diagnostic ?"
        } else {
            this.isActive = 'partieB'
            this.cartoucheWidthA = 345
            this.title = "Comment le traitement est-il défini ?"
        }

        this.tittleCartoucheA = this.scene.add.rectangle(0, 0, 0, 210, Colors.Elmt.MainBlue).setOrigin(0)
        this.tittleCartoucheB = this.scene.add.rectangle(1920, 0, 1920, 210, Colors.Elmt.MidBlue).setOrigin(0)

        // this.ctaRectA.setInteractive({ useHandCursor: true }).on('pointerdown', () => { this.switchToPartieA() })
        this.ctaRectA = this.scene.add.rectangle(105, 105, 200, 80, Colors.Elmt.MainBlue).setOrigin(0.5).setAlpha(0.5).setAlpha(0)
        this.ctaRectB = this.scene.add.rectangle(1715, 105, 200, 80, Colors.Elmt.MidBlue).setOrigin(0.5).setAlpha(0.5).setAlpha(0)

        this.ctaTextA = this.scene.add.text(155, 105, "PARTIE 1", {
            fontFamily: 'CenturyGothicBold',
            fontSize: 36,
            color: Colors.Text.White,
            align: 'center',
        }).setOrigin(0.5).setAlpha(0);


        this.ctaTextB = this.scene.add.text(1765, 105, "PARTIE 2", {
            fontFamily: 'CenturyGothicBold',
            fontSize: 36,
            color: Colors.Text.White,
            align: 'center',
        }).setOrigin(0.5).setAlpha(0);


        this.bigTitle = this.scene.add.text(this.scene.width / 2, 105, this.title.toUpperCase(), {
            fontFamily: 'DKButterfly',
            fontSize: 68,
            color: Colors.Text.White,
            align: 'center',
        }).setOrigin(0.5).setAlpha(0);

        this.rectBlur = this.scene.add.rectangle(0, 0, 1920, 210, Colors.Elmt.White).setOrigin(0).setAlpha(0)
        
        
        this.add(this.tittleCartoucheB);
        this.add(this.tittleCartoucheA);
        this.add(this.ctaRectA);
        this.add(this.ctaRectB);
        this.add(this.ctaTextA);
        this.add(this.ctaTextB);
        this.add(this.bigTitle);
        this.add(this.rectBlur);


    }

    switchToPartieB() {
        this.isActive = 'partieB'
        this.cartoucheWidthA = 345
        if (this.level ===7) {
            this.renfoState()
        }
        
        this.scene.tweens.add({
            targets: [this.scene.activiteTitle, this.scene.activiteContent],
            alpha: 0,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.scene.allItems.forEach((item, id) => {
                    this.scene.tweens.add({
                        targets: item,
                        alpha: 0,
                        duration: 300,
                        ease: 'Power2',
                        delay: id * 300,
                        onComplete: () => {
                            if (id === this.scene.allItems.length - 1) {
                                this.scene.allItems.forEach((item) => {item.destroy()})
                                this.scene.allItems = []
                                this.scene.createItems(1)
                                this.scene.tweens.add({
                                    targets: [this.ctaRectA, this.ctaRectB, this.ctaTextA, this.ctaTextB, this.bigTitle, this.scene.startBtn],
                                    alpha: 0,
                                    duration: 500,
                                    ease: 'Power2',
                                    onComplete: () => {
                                        // Changement du titre APRÈS sa disparition
                                        this.bigTitle.setText("Comment le traitement est-il défini ?".toUpperCase())
                                        this.ctaTextA.setAlpha(0.5).setScale(0.6)
                                        this.ctaTextB.setAlpha(1).setScale(1)
                                        this.ctaRectB.disableInteractive()
                                        // Activation du bouton A pour permettre le retour en Partie A
                                        this.ctaRectA.setInteractive({ useHandCursor: true }).off('pointerdown').on('pointerdown', () => { this.switchToPartieA() })
                                        this.scene.tweens.add({
                                            targets: this.tittleCartoucheA,
                                            width: this.cartoucheWidthA,
                                            duration: 500,
                                            ease: 'Power2',
                                            onComplete: () => {
                                                this.scene.tweens.add({
                                                    targets: [this.ctaRectA, this.ctaRectB, this.ctaTextA, this.ctaTextB, this.bigTitle],
                                                    alpha: 1,
                                                    duration: 500,
                                                    ease: 'Power2',
                                                    onComplete: () => {
                                                        this.scene.setItemsStatus()
                                                        this.scene.allItems.forEach((item, id) => {
                                                            this.scene.tweens.add({
                                                                targets: item,
                                                                alpha: 1,
                                                                duration: 300,
                                                                ease: 'Power2',
                                                                delay: id * 300,
                                                                onComplete: () => {
                                                                    if (id === this.scene.allItems.length - 1) {
                                                                        [this.scene.activiteTitle, this.scene.activiteContent, this.scene.startBtn].forEach((el) => { el.setAlpha(1) })
                                                                    }
                                                                }
                                                            })
                                                        })
                                                    }
                                                })
                                            }
                                        });
                                    }
                                })
                            }
                        }
                    })
                })
            }
        })
    }

    switchToPartieA() {
        this.isActive = 'partieA'
        this.cartoucheWidthA = 1575
          if (this.level ===7) {
            this.renfoState()
        }
        this.scene.tweens.add({
            targets: [this.scene.activiteTitle, this.scene.activiteContent],
            alpha: 0,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.scene.allItems.forEach((item, id) => {
                    this.scene.tweens.add({
                        targets: item,
                        alpha: 0,
                        duration: 300,
                        ease: 'Power2',
                        delay: id * 300,
                        onComplete: () => {
                            if (id === this.scene.allItems.length - 1) {
                                this.scene.allItems.forEach((item) => {item.destroy()})
                                this.scene.allItems = []
                                this.scene.createItems(0)
                                this.scene.tweens.add({
                                    targets: [this.ctaRectA, this.ctaRectB, this.ctaTextA, this.ctaTextB, this.bigTitle, this.scene.startBtn],
                                    alpha: 0,
                                    duration: 500,
                                    ease: 'Power2',
                                    onComplete: () => {
                                        // Changement du titre APRÈS sa disparition
                                        this.bigTitle.setText("Qu'est-ce qu'un diagnostic ?".toUpperCase())
                                        this.ctaTextA.setAlpha(1).setScale(1)
                                        this.ctaTextB.setAlpha(0.5).setScale(0.6)
                                        this.ctaRectA.disableInteractive()
                                        this.ctaRectB.setInteractive({ useHandCursor: true }).off('pointerdown').on('pointerdown', () => { this.switchToPartieB() })
                                        this.scene.tweens.add({
                                            targets: this.tittleCartoucheA,
                                            width: this.cartoucheWidthA,
                                            duration: 500,
                                            ease: 'Power2',
                                            onComplete: () => {
                                                this.scene.tweens.add({
                                                    targets: [this.ctaRectA, this.ctaRectB, this.ctaTextA, this.ctaTextB, this.bigTitle],
                                                    alpha: 1,
                                                    duration: 500,
                                                    ease: 'Power2',
                                                    onComplete: () => {
                                                        // Si le level est >= 4, on revient en Partie A avec tous les items open et le premier actif
                                                        if (this.level >= 4) {
                                                            this.scene.startBtn.setTextContent("Lancer")
                                                            this.scene.allItems.forEach((item, id) => {
                                                                this.scene.tweens.add({
                                                                    targets: item,
                                                                    alpha: 1,
                                                                    duration: 500,
                                                                    ease: 'Power2',
                                                                    delay: id * 100,
                                                                    onComplete: () => {
                                                                        if (id === 0) {
                                                                            item.setActive();
                                                                        } else {
                                                                            item.setOpen();
                                                                        }
                                                                        if (id === this.scene.allItems.length - 1) {
                                                                            [this.scene.activiteTitle, this.scene.activiteContent, this.scene.startBtn].forEach((el) => { el.setAlpha(1) })
                                                                        }
                                                                    }
                                                                })
                                                            })
                                                        } else {
                                                            // Sinon, comportement normal avec setItemsStatus
                                                            this.scene.setItemsStatus()
                                                            this.scene.allItems.forEach((item, id) => {
                                                                this.scene.tweens.add({
                                                                    targets: item,
                                                                    alpha: 1,
                                                                    duration: 300,
                                                                    ease: 'Power2',
                                                                    delay: id * 300,
                                                                    onComplete: () => {
                                                                        if (id === this.scene.allItems.length - 1) {
                                                                            [this.scene.activiteTitle, this.scene.activiteContent, this.scene.startBtn].forEach((el) => { el.setAlpha(1) })
                                                                        }
                                                                    }
                                                                })
                                                            })
                                                        }
                                                    }
                                                })
                                            }
                                        });
                                    }
                                })
                            }
                        }
                    })
                })

            }
        })
    }

    // switchToPartieA() {
    // this.isActive = 'partieA'
    // this.scene.menuOut()
    // this.bigTitle.setAlpha(0)
    // this.bigTitle.setText("Qu'est-ce qu'un diagnostic ?".toUpperCase())
    // this.scene.tweens.add({
    //     targets: this.tittleCartoucheA,
    //     width: 1575,
    //     duration: 500,
    //     ease: 'Power2',
    //     onComplete: () => {
    // this.bigTitle.setAlpha(1)
    // this.ctaRectA.disableInteractive()
    // // this.partieCtaA.setInteractive({ useHandCursor: true })
    // this.ctaRectA.setInteractive({ useHandCursor: true }).on('pointerdown', () => { this.switchToPartieA() })
    // this.partieCtaA.setInteractive({ useHandCursor: true }).on('pointerdown', () => { this.switchToPartieB() })

    // this.scene.partieAItems.forEach((item) => { item.setAlpha(1) });
    // this.scene.partieBItems.forEach((item) => { item.setAlpha(0) });
    // }
    // });
    // this.scene.tweens.add({
    //     targets: this.partieCtaB,
    //     alpha: 0.5,
    //     scale: 0.8,
    //     duration: 500,
    //     ease: 'Power2',
    // })
    // this.scene.tweens.add({
    //     targets: this.partieCtaA,
    //     alpha: 1,
    //     scale: 1,
    //     duration: 500,
    //     ease: 'Power2',
    // })
    // }

    checkLevel(level) {
        // console.log(level)
        if (level <= 3) {
            // console.log("A")
            // this.switchToPartieA();
            // this.partieCtaA.disableInteractive();
        } else {
            // console.log("B")
            // this.switchToPartieB();
            // this.partieCtaA.setInteractive({ useHandCursor: true }).on('pointerdown', () => { this.switchToPartieB() })
        }
    }

    menuIn() {
        this.scene.tweens.add({
            targets: this.tittleCartoucheA,
            width: this.cartoucheWidthA,
            duration: 500,
            ease: 'Power2',
        })
        this.scene.tweens.add({
            targets: this.tittleCartoucheB,
            x: this.cartoucheWidthA,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.tittleCartoucheB.x = 0
                this.ctaRectA.setAlpha(1)
                this.ctaRectB.setAlpha(1)
                this.scene.tweens.add({
                    targets: [this.ctaTextA, this.ctaTextB],
                    scale: 1,
                    duration: 500,
                    ease: 'Power2',
                    onComplete: () => {
                        this.bigTitle.setAlpha(1)
                        if (this.groupIndex === 1) {
                            this.ctaTextA.setAlpha(0.5).setScale(0.6)
                            this.ctaRectA.setInteractive({ useHandCursor: true }).off('pointerdown').on('pointerdown', () => { this.switchToPartieA() })
                            this.ctaTextB.setAlpha(1).setScale(1)
                            this.ctaRectB.disableInteractive()
                        }
                        if (this.groupIndex === 0) {
                            this.ctaTextB.setAlpha(0.5).setScale(0.6)
                            this.ctaTextA.setAlpha(1).setScale(1)
                            this.ctaRectA.disableInteractive()
                            // Active le bouton B seulement si level >= 4
                            if (this.level >= 4) {
                                this.ctaRectB.setInteractive({ useHandCursor: true }).off('pointerdown').on('pointerdown', () => { this.switchToPartieB() })
                            }
                        }
                        this.scene.setItemsStatus()
                        console.log('prefab this.level', this.level);

                    }
                })

            }
        })
    }

    menuOut(activity) {
        this.tittleCartoucheB.x = this.cartoucheWidthA
        this.scene.tweens.add({
            targets: [this.ctaRectA, this.ctaRectB, this.ctaTextA, this.ctaTextB, this.bigTitle],
            alpha: 0,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this.tittleCartoucheA,
                    width: 0,
                    duration: 500,
                    ease: 'Power2',

                })
                this.scene.tweens.add({
                    targets: this.tittleCartoucheB,
                    x: 1920,
                    duration: 500,
                    ease: 'Power2',
                    onComplete: () => {
                        this.scene.soundCut()
                        this.scene.scene.start(activity)
                    }

                })
            }
        });
    }

    renfoState(state){
        console.log('renfoState', state);
        let alphaIndex
        if(state){
            alphaIndex = 0.5
        }else if (!state){
            alphaIndex = 0
        }
        this.scene.tweens.add({
            targets: this.rectBlur,
            alpha: alphaIndex,
            duration: 500,
            ease: 'Power2',
        })
    }
}
